import React from 'react';
import { observer, inject } from 'mobx-react';
import { RemoveScroll } from 'react-remove-scroll';

import First from '@/pages/first';
import { VisualViewport } from '@/components/loadFirstScreen';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { isBank } from '@/config/core';

const MainWrapper = React.lazy(() => import(/* webpackChunkName: 'lazyLoadPage' */ '@/pages/main/wrapper'));

const PREFIX = 'chatbot';
const getRootClassName = () => {
  const classname = isBank() ? 'chatbot-bank' : '';

  return `${PREFIX} ${classname}`;
};

@inject(getChildInject('firstInit', 'inputStore'))
@observer
export default class Index extends React.Component {
  render() {
    const { firstInit } = this.props;

    const headerExtraTop = firstInit.inputStore.headerExtraTop;
    const isInputFocus = firstInit.inputStore.isInputFocus;

    return (<VisualViewport
      id={PREFIX}
      className={getRootClassName()}
      style={{ paddingTop: `${headerExtraTop}px` }}
    >
      <RemoveScroll
        className="session-area-scrollable"
        enabled={isInputFocus && (!this.isIos || typeof window.visualViewport !== 'undefined')}
        style={{ height: '100%' }}
      >
        <React.Suspense fallback={<First {...this.props} />}>
          <MainWrapper {...this.props} />
        </React.Suspense>
      </RemoveScroll>
    </VisualViewport>);
  }
}
